export function useIsPopout() {
  return window.opener != null && window.opener !== window;
}
